"use strict";
exports.__esModule = true;
var ChartBreakdownRequest = /** @class */ (function () {
    function ChartBreakdownRequest(_a) {
        var breakdown = _a.breakdown, filter = _a.filter;
        var _this = this;
        this.toJSON = function () { return ({
            breakdown: _this.breakdown,
            filter: _this.filter
        }); };
        this.breakdown = breakdown;
        this.filter = filter;
    }
    ChartBreakdownRequest.fromJSON = function (json) {
        var _a = Object.assign({}, json), breakdown = _a.breakdown, filter = _a.filter;
        if (typeof breakdown !== 'string')
            throw new Error('.breakdown must be a string');
        if (!Array.isArray(filter) && filter !== undefined && filter !== null)
            throw new Error('.filter must be a array');
        var _filter = filter ? filter.map(function (item) { return item; }) : null;
        return new ChartBreakdownRequest({
            breakdown: breakdown,
            filter: _filter
        });
    };
    return ChartBreakdownRequest;
}());
exports["default"] = ChartBreakdownRequest;
